import { cn } from '@/shared/lib/cn';

/**
 * Ilustracao SVG inline para a tela 404 — estilo "Obsidian Pulse":
 * line-work geometrico, primary-as-accent (verde), grid background sutil.
 *
 * Composicao: grid de mapa (linhas finas em surface-high), road tracejada
 * em secondary-text e um pin "?" central com glow primary. Substitui o
 * emoji/texto puro do placeholder Phase 02.
 *
 * Feita a partir da OPCAO A "Map Pin com glow" (ver
 * __mocks__/edge/404/option-a.tsx) — escolhida por aderir mais ao estilo
 * editorial dark-mode do produto e reusar 100% do palette do design system.
 */
export interface NotFoundIllustrationProps {
  className?: string;
}

export function NotFoundIllustration({ className }: NotFoundIllustrationProps) {
  return (
    <svg
      viewBox="0 0 320 240"
      fill="none"
      aria-hidden
      className={cn('h-auto w-[260px] sm:w-[320px]', className)}
      data-testid="not-found-illustration"
    >
      <line x1="0" y1="60" x2="320" y2="60" stroke="var(--surface-high)" strokeWidth="1" />
      <line x1="0" y1="120" x2="320" y2="120" stroke="var(--surface-high)" strokeWidth="1" />
      <line x1="0" y1="180" x2="320" y2="180" stroke="var(--surface-high)" strokeWidth="1" />
      <line x1="80" y1="0" x2="80" y2="240" stroke="var(--surface-high)" strokeWidth="1" />
      <line x1="160" y1="0" x2="160" y2="240" stroke="var(--surface-high)" strokeWidth="1" />
      <line x1="240" y1="0" x2="240" y2="240" stroke="var(--surface-high)" strokeWidth="1" />

      <path
        d="M 30 200 Q 110 180 140 130 T 210 60 Q 250 30 300 50"
        stroke="var(--secondary-text)"
        strokeWidth="1.5"
        strokeDasharray="4 4"
        fill="none"
        opacity="0.4"
      />

      <circle cx="160" cy="120" r="40" fill="rgba(19,236,91,0.15)" />
      <circle
        cx="160"
        cy="120"
        r="28"
        fill="rgba(19,236,91,0.12)"
        stroke="var(--primary)"
        strokeWidth="2"
      />
      <text
        x="160"
        y="130"
        textAnchor="middle"
        fill="var(--primary)"
        fontSize="22"
        fontWeight="800"
        fontFamily="Inter, sans-serif"
      >
        ?
      </text>
    </svg>
  );
}
